import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { CondominiumIntercomPage } from './condominium-intercom';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CondominiumIntercomPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CondominiumIntercomPage)
	],
})
export class CondominiumIntercomPageModule {

}



// WEBPACK FOOTER //
// ./src/pages/condominium-intercom/condominium-intercom.module.ts